import clx from 'classnames';
import { useFm, useParams, useToast } from '@web3/base-hooks';
import { appPath } from '@web3/base-utils';
import { HomeDataDTO } from '@/types/home';
import { initialWindowType } from '@/hooks/media';
import { Button } from '@/components';
import { NoSSR } from '@web3/base-components';
import { Event, Page } from '@/config/track-config';
import { useWsotShare } from '@/hooks/useWsotShare';
import { Time } from './Time';
import styles from './style.module.scss';
import { useUserStatus } from '@/hooks/useUserStatus';
import { LoginStatus, UserStatus } from '@/types/user';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { get } from 'lodash-es';
import { useRegisterModal } from '@/hooks/useRegisterModal';
import { TOTAL_REWARD_AMOUNT } from '@/utils/constant';
import { scTrack } from '@web3/base-tracking';
import { BANNER_TITLE_IMG } from '@/constants';
import Image from 'next/image';
dayjs.extend(isBetween);

export const Banner = ({ homeData }: { homeData: HomeDataDTO }) => {
  const fm = useFm();
  const { isMobile } = initialWindowType;
  const { locale } = useParams();
  const currentTime = dayjs();
  const isEnded = currentTime.isAfter(dayjs(homeData?.endTime));
  const isNotStarted = currentTime.isBefore(dayjs(homeData?.startTime));
  const { openRegisterModal, checkStatusAndRegister } = useRegisterModal();
  const { toastFail } = useToast();

  const { loginStatus, userStatus } = useUserStatus();

  // share
  const { showShare } = useWsotShare({
    projectNum: homeData?.projectList?.length,
    joinAddressCount: homeData?.registerCount,
  });
  const handleClickShare = () => {
    showShare();
  };

  // 点击我的奖励
  const handleClickMyRewards = () => {
    if (loginStatus === LoginStatus.NONE) {
      openRegisterModal();
      return;
    }
    if (userStatus === UserStatus.NOT_REGISTER) {
      toastFail(fm('yetToRegister'));
      return;
    }
    window.open(`/${locale}${appPath}/profile`, '_blank');
  };

  const JoinNowButton = (
    <Button
      size={!isMobile ? 'x-large' : 'small'}
      variant="primary"
      className={styles.forsted}
      onClick={() => {
        checkStatusAndRegister();
      }}
      data-spm-even={Event.Web3UserClick}
      data-spm-data={JSON.stringify({
        page_name: Page.HomePage,
        button_name: 'JoinNow',
      })}
    >
      {fm('myRewards')}
    </Button>
  );

  const MyRewardsButton = (
    <Button
      size={!isMobile ? 'x-large' : 'small'}
      variant="primary"
      className={styles.forsted}
      onClick={handleClickMyRewards}
      data-spm-even={Event.Web3UserClick}
      data-spm-data={JSON.stringify({
        page_name: Page.HomePage,
        button_name: 'MyRewards',
      })}
    >
      <span>{fm('myRewards')}</span>
    </Button>
  );

  const ShareButton = (
    <Button
      size={!isMobile ? 'x-large' : 'small'}
      className={styles.shareBtn}
      variant="secondaryBrand"
      onClick={handleClickShare}
      data-spm-even={Event.Web3UserClick}
      data-spm-data={JSON.stringify({
        page_name: Page.HomePage,
        button_name: 'ShareAIDOL',
      })}
    >
      <span>{fm('share')}</span>
    </Button>
  );

  // 按钮展示逻辑比较复杂, 适当冗余
  let Buttons = null;
  if (loginStatus === LoginStatus.NOT_READY) {
    // 状态没准备好
    Buttons = null;
  } else if (isNotStarted) {
    // 活动没开始
    Buttons = null;
  } else if (!isEnded) {
    // 活动进行中
    if (
      loginStatus === LoginStatus.NONE ||
      [UserStatus.NOT_REGISTER, UserStatus.NOT_READY].includes(userStatus)
    ) {
      // 未登录或者未报名
      Buttons = JoinNowButton;
    } else if (userStatus !== UserStatus.NOT_READY) {
      // 已登录且已报名
      Buttons = (
        <>
          {MyRewardsButton}
          {ShareButton}
        </>
      );
    }
  } else {
    // 活动已结束，统一展示两个按钮
    Buttons = (
      <>
        {MyRewardsButton}
        {ShareButton}
      </>
    );
  }

  return (
    <>
      <div className={styles.bannerWrap}>
        <div className={styles.contentWrapper}>
          <Image
            className={styles.topTitle}
            loader={({ src }) => src}
            src={BANNER_TITLE_IMG}
            width={360}
            height={209}
            alt="AI-DOL SUPERSTAR"
          />
          <h2 className={styles.title}>{fm('battleForDebut')}</h2>
          <div
            className={styles.subTitle}
            dangerouslySetInnerHTML={{
              __html:
                `${fm('castVoteAndClaimPrize', { amount: TOTAL_REWARD_AMOUNT })}
               ${fm('aiFutureTradeVoteWin')}
              `.replace(/\n/g, '<br>'),
            }}
          ></div>
          <>
            <div
              className={clx(['flex justify-center'], {
                'mt-[32px]': !isMobile,
                'mt-[16px]': isMobile,
              })}
            >
              <NoSSR>
                <Time
                  startTime={get(homeData, 'startTime', 0)}
                  endTime={get(homeData, 'endTime', 0)}
                  isEnded={isEnded}
                  isNotStarted={isNotStarted}
                />
              </NoSSR>
            </div>
            <div className={styles.btns}>{Buttons}</div>
          </>
        </div>
      </div>
    </>
  );
};
